import ENV from "../Environments";
import { isWeb, iosOrAndroid, tabView } from "./utility";
import { MobileType } from "./constants";
import { formProcessor } from "../utils/onLoad";

const checkIfNewTab = (uri) => {
	if (uri.includes("myairtel://") && uri.includes(ENV.getAppUrl())) {
		window.localStorage.setItem("isNewTab", "true");
	}
};

export const tabLinkHandler = (uri, prefix) => {
	uri = uri.replace(/ /g, "+");
	if (uri.includes("?")) {
		uri = uri + "%26isTabView=true";
	} else {
		uri = uri + "?isTabView=true";
	}
	uri = `${prefix}${ENV.getAppUrl()}${uri}`;
	checkIfNewTab(uri);
	window.location.href = uri;
};

const processDeeplinkType = (deeplink) => {
	if (
		iosOrAndroid() === MobileType.ANDROID &&
		deeplink.uri &&
		deeplink.uri !== ""
	) {
		window.location.href = deeplink.uri;
	} else if (
		iosOrAndroid() === MobileType.IOS &&
		deeplink.iuri &&
		deeplink.iuri !== ""
	) {
		window.location.href = deeplink.iuri;
	}
};

const urlHandlingForApp = (uri, iuri) => {
	const isExternal = uri.indexOf("/") !== 0;
	if (isExternal) {
		checkIfNewTab(uri);
		processDeeplinkType({ uri, iuri });
	} else {
		if (tabView.isTabView()) {
			if (iosOrAndroid() === MobileType.IOS && iuri) {
				tabLinkHandler(iuri, "myairtel://webview?ax=");
			} else if (iosOrAndroid() === MobileType.ANDROID && uri) {
				tabLinkHandler(uri, "myairtel://webview?au=");
			}
		} else {
			// handleHistoryPush(history, uri);
		}
	}
};

const processCtaClick = (cardCta) => {
	if (!isWeb()) {
		urlHandlingForApp(cardCta.deeplink.uri, cardCta.deeplink.iuri);
	} else {
		if (cardCta.deeplink.wuri) {
			const isExternal = cardCta.deeplink.wuri.indexOf("/") !== 0;
			if (isExternal) {
				window.open(cardCta.deeplink.wuri, "_blank"); /* url not native to us */
				window.open("about:blank", "_self");
				window.close();
			} else {
				const navigate = formProcessor.getNavigate();
				navigate && navigate(cardCta.deeplink.wuri);
				navigate && navigate(0);
			}
		}
	}
};

export { processCtaClick };
